module.exports = __webpack_public_path__ + "img/services-hero-m.e035560f.jpg";